import React from "react";
import Skeleton from "../skeleton";

const Dekstop = () => (

	<>
		<div className="card">
			<div className="list-reviews">
				<div className="product">
					<Skeleton
						width="213px"
						height="140px"
					/>
					<Skeleton
						width="88px"
						height="15px"
					/>
					<Skeleton
						width="127px"
						height="15px"
					/>
					<Skeleton
						width="169px"
						height="15px"
					/>
					<div className="section-bs">
						<Skeleton
							width="34px"
							height="34px"
						/>
						<Skeleton
							width="160px"
							height="32px"
						/>
					</div>
				</div>
				<div className="section-reviews">
					<div className="profile">
						<Skeleton
							width="60px"
							height="60px"
							borderRadius="50%"
						/>
						<div className="" style={{ width: "420px" }}>
							<Skeleton
								width="122px"
								height="15px"
							/>
							<Skeleton
								width="152px"
								height="15px"
							/>
						</div>
						<Skeleton
							width="88px"
							height="15px"
						/>
					</div>
					<div className="reviews">
						<Skeleton
							width="158px"
							height="15px"
						/>
						{
							Array.from({ length: 3 }, (value, id) => (
								<Skeleton
									key={id}
									width="598px"
									height="15px"
								/>
							))
						}
						<Skeleton
							width="467px"
							height="15px"
						/>
						{
							Array.from({ length: 2 }, (velue, id) => (
								<div className="section-place" key={id}>
									<Skeleton
										width="16px"
										height="16px"
										borderRadius="50%"
									/>
									<Skeleton
										width="88px"
										height="15px"
									/>
									<span style={{ color: "#dfe3e8" }}> : </span>
									<Skeleton
										width="88px"
										height="15px"
									/>
								</div>
							))
						}
					</div>
					<hr />
					<div className="comment-section">
						<Skeleton
							width="88px"
							height="12px"
						/>
						<Skeleton
							width="16px"
							height="16px"
							borderRadius="50%"
						/>

					</div>
				</div>
			</div>
		</div>
		<style jsx>
			{`
				.card{
						max-width: 888px;
						padding: 18px;
						margin-top: 20px;
            border-radius: 8px;
						border: 1px solid #dfe3e8;
				}
				.list-reviews{
						display: flex;
						gap: 20px;
				}
				.product{
						display: flex;
						flex-direction: column;
						align-items: center;
				}
				.section-bs{
						display: flex;
						gap: 10px;
				}
				.section-reviews{
						max-width: 598px;
				}
				.profile{
						display: flex;
						justify-content: space-between;
						align-items: center;
				}
				.section-place{
						display: flex;
						gap: 10px;
				}
				hr{
						margin-top: 10px;
						border: 1px solid #dfe3e8;
				}
				.comment-section{
						display: flex;
						justify-content: space-between;
				}
		`}
		</style>
	</>

);

export default Dekstop;
